var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gotop),expression:"gotop"}],staticClass:"backTop",style:({'opacity':_vm.opacity}),on:{"mouseenter":_vm.enterBackTop,"mouseout":_vm.outBackTop,"click":_vm.handleScrollTop}},[_c('div',{staticClass:"back"})])
}
var staticRenderFns = []

export { render, staticRenderFns }